(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rg-sales-downloads"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
  const link = event.target.closest('[data-rg-download]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  if (link.getAttribute('aria-busy') === 'true') return;
  const status = link.closest('.rg-sales-downloads').querySelector('[role="status"]');
  link.setAttribute('aria-busy', 'true');
  status.textContent = 'Preparing your download…';
  try {
    const response = await fetch(link.href, { credentials: 'omit' });
    if (!response.ok) throw new Error('Download unavailable');
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = link.download;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    status.textContent = 'Download started. On mobile, check Downloads or use Share to save the file.';
  } catch {
    status.textContent = 'Use the Open link beside this file, then choose Save or Download in your browser.';
  } finally {
    link.removeAttribute('aria-busy');
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rg-sales-share"] && !Shopify.designMode) return;
  try {
    (() => {
  const prepared = new WeakMap();
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.rg-sales-share button');
    if (!button) return;
    const box = button.closest('.rg-sales-share');
    const status = box.querySelector('[role="status"]');
    const text = box.querySelector('textarea').value;
    if (button.hasAttribute('data-rg-media')) {
      const downloads = box.closest('.product-form-wrapper')?.querySelector('.rg-sales-downloads') || document.querySelector('.rg-sales-downloads');
      if (downloads) { downloads.open = true; downloads.scrollIntoView({behavior: 'smooth', block: 'center'}); downloads.querySelector('summary').focus(); }
      else status.textContent = 'No downloadable media is available for this product.';
      return;
    }
    if (button.hasAttribute('data-rg-copy')) {
      try { await navigator.clipboard.writeText(text); status.textContent = 'Product details copied. Prices and ALTCODE are excluded.'; }
      catch { const field = box.querySelector('textarea'); field.closest('details').open = true; field.focus(); field.select(); status.textContent = 'Select Copy from your phone’s text menu.'; }
      return;
    }
    if (!navigator.share || !navigator.canShare) {
      status.textContent = 'This browser cannot share media files. Download the media and copy the product details, then attach them in WhatsApp.';
      return;
    }
    const ready = prepared.get(box);
    if (ready) {
      try {
        await navigator.share({files: ready, text});
        status.textContent = 'Share menu closed. If WhatsApp omitted the text, use Copy product details.';
      } catch (error) {
        status.textContent = error.name === 'AbortError' ? 'Sharing canceled. Your files are ready to try again.' : 'Your phone could not share these files together. Use Download media and Copy product details.';
      }
      return;
    }
    const links = [...box.querySelectorAll('[data-rg-files] a')];
    if (!links.length || box.querySelector('[data-rg-unsupported]')) {
      status.textContent = 'Some media cannot be attached automatically. Use Download media and Copy product details.';
      return;
    }
    button.disabled = true;
    const files = [];
    try {
      for (const [index, link] of links.entries()) {
        status.textContent = 'Preparing file ' + (index + 1) + ' of ' + links.length + '…';
        const response = await fetch(link.href, {credentials: 'omit'});
        if (!response.ok) throw new Error('File unavailable');
        const blob = await response.blob();
        files.push(new File([blob], link.dataset.filename, {type: blob.type || (link.dataset.filename.endsWith('.mp4') ? 'video/mp4' : 'image/jpeg')}));
      }
      if (!navigator.canShare({files, text})) throw new Error('Unsupported files');
      prepared.set(box, files);
      button.textContent = 'Open share menu';
      status.textContent = files.length + ' files ready. Tap Open share menu and choose WhatsApp. If text is omitted, use Copy product details.';
    } catch {
      status.textContent = 'Unable to prepare all media for this phone. Use Download media and Copy product details; no partial set was shared.';
    } finally { button.disabled = false; }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
